// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"138b21da","401":"ea821028","507":"c7aa7a11","621":"2cec8f4f","879":"563a91df"}[chunkId] + ".chunk.js";
};